module.exports = __webpack_public_path__ + "img/third-2.d1ba9114.webp";